import { bootstrap } from './bootstrap'
import { ConsentProviderPort } from './ports'
import { logger } from '@otto-ec/eprivacy-shared'
export type { ConsentProviderPort } from './ports'

export async function bootstrapConsentProvider(): Promise<
  ConsentProviderPort | undefined | void
> {
  try {
    return await bootstrap()
  } catch (error) {
    logger.error(
      new Error(`Failed to bootstrap onetrust-sdk`, {
        cause: error,
      })
    )
  }
}
